var map = {
	"./template.betgalaxy": 2064,
	"./template.betgalaxy.tsx": 2064,
	"./template.betprofessor": 1864,
	"./template.betprofessor.tsx": 1864,
	"./template.betroyale": 1865,
	"./template.betroyale.tsx": 1865,
	"./template.default": 708,
	"./template.default.tsx": 708,
	"./template.fiestabet": 1866,
	"./template.fiestabet.tsx": 1866,
	"./template.puntcity": 1867,
	"./template.puntcity.tsx": 1867,
	"./template.puntgenie": 1868,
	"./template.puntgenie.tsx": 1868,
	"./template.questbet": 1869,
	"./template.questbet.tsx": 1869,
	"./template.ts": 997,
	"./template.volcanobet": 1870,
	"./template.volcanobet.tsx": 1870,
	"./template.wellbet": 1871,
	"./template.wellbet.tsx": 1871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2792;